type LoadingIndicatorVariant = "dots" | "bar";

type LoadingIndicatorProps = {
  label: string;
  variant?: LoadingIndicatorVariant;
};

const DOT_DELAYS_MS = [0, 150, 300];

export const LoadingIndicator = ({
  label,
  variant = "dots",
}: LoadingIndicatorProps) => {
  if (variant === "bar") {
    return (
      <output className="flex flex-col gap-2" aria-live="polite">
        <div className="h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-neutral-200">
          <div className="h-full w-1/3 rounded-full bg-neutral-400 motion-safe:animate-bar-elastic" />
        </div>
        <p key={label} className="text-neutral-500 motion-safe:animate-fade-in">
          {label}
        </p>
      </output>
    );
  }

  return (
    <output className="flex items-center gap-2" aria-live="polite">
      <div className="flex gap-1">
        {DOT_DELAYS_MS.map((delayMs) => (
          <span
            key={delayMs}
            className="h-2 w-2 rounded-full bg-neutral-400 motion-safe:animate-dot-bounce"
            style={{ animationDelay: `${delayMs}ms` }}
          />
        ))}
      </div>
      <p className="text-neutral-500">{label}</p>
    </output>
  );
};
